var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"delivery-view"}},[_c('b-container',{staticStyle:{"margin-top":"40px"}},[(_vm.user.role === 'admin')?_c('list-delivery'):_vm._e(),(_vm.user.role === 'store')?_c('list-store-delivery'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }